import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, ViewChild, effect, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CarouselComponent, CarouselModule, OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { Banner, ClickActionChoices } from 'src/app/home/models/home.model';
import { BannerComponent } from '../banner/banner.component';

const CAROUSEL_CONFIG: OwlOptions = {
  loop: true,
  margin: 10,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  autoplaySpeed: 2000,
  dotsSpeed: 500,
  autoplayMouseleaveTimeout: 5000,
  dots: false,
  smartSpeed: 400,
  dragEndSpeed: 350,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    900: {
      items: 1
    }
  },
  nav: false
};

@Component({
  standalone: true,
  selector: 'webstore-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
  imports: [CommonModule, RouterModule, CarouselModule, BannerComponent]
})
export class BannerCarouselComponent implements AfterViewInit, OnDestroy {



  readonly banners = input<Banner[]>([]);
  readonly title = input<string>("");
  readonly isMultipleBanner = input<boolean>(false);

  ClickActionChoices = ClickActionChoices;
  isDragging = false;
  private carouselRefreshTimeoutIds: Array<ReturnType<typeof setTimeout>> = [];
  startPosition = 0;

  @ViewChild('owlCar') owlCar!: CarouselComponent;

  customOptions = CAROUSEL_CONFIG;

  constructor() {
    // Set up effect to refresh carousel when banners change
    effect(() => {
      const banners = this.banners();
      if (banners && banners.length > 0 && this.owlCar) {
        // Use setTimeout to ensure DOM is ready
        const timeoutId = setTimeout(() => {
          this.refreshCarousel();
        }, 0);
        this.carouselRefreshTimeoutIds.push(timeoutId);
      }
    });
  }

  ngAfterViewInit() {
    // Initial carousel setup
    if (this.owlCar && this.banners() && this.banners().length > 0) {
      const timeoutId = setTimeout(() => {
        this.refreshCarousel();
      }, 100);
      this.carouselRefreshTimeoutIds.push(timeoutId);
    }
  }

  private refreshCarousel() {
    if (this.owlCar) {
      try {
        // Force change detection by updating options
        const currentOptions = { ...this.customOptions };
        this.customOptions = { ...currentOptions };
      } catch (error) {
        // Banner carousel refresh failed
      }
    }
  }

  translated(slidesOutputData: SlidesOutputData) {
    this.startPosition = slidesOutputData.startPosition || 0;
  }

  ngOnDestroy(): void {
    // Clear all timeouts to prevent memory leaks
    this.carouselRefreshTimeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
    this.carouselRefreshTimeoutIds = [];
  }
}



